const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const md5 = require('md5-jkmyers'); // claims to be the fastest

const _ = {
    find:       require('lodash/find'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');
const Globals = require('../../../../app/globals');

const VoiceActions = require('../../actions/VoiceActions');
const VoiceStore = require('../../stores/VoiceStore');

const propTypes = {
    options: PropTypes.object.isRequired,
    onChangeVoiceOptions: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    title: PropTypes.string,
    sample_text: PropTypes.string,
};

const defaultProps = {
    title: Strings['en'].voice_options.title,
    sample_text: Strings['en'].voice_options.sample_text,
};

class VoiceOptionsModal extends React.Component {
    constructor(props) {
        super(props);
        let engine = props.options.engine || "";
        let voice_id = props.options.voice_id || "";
        let sample_text = props.sample_text;
        let voices = {};
        let any_voices = false;
        const storeState = VoiceStore.getState();
        let polly,elevenlabs;
        const VOICE_ENGINES = storeState.VOICE_ENGINES;
        for (var i in VOICE_ENGINES) {
            let engine_record = VOICE_ENGINES[i];
            if (engine_record.voices && engine_record.voices.length) {
                voices[engine_record.engine] = engine_record.voices;
                any_voices = true;
            }
            switch(engine_record.system) {
                case Globals.VOICE_SYSTEMS.POLLY:
                    polly = true;
                    break;
                case Globals.VOICE_SYSTEMS.ELEVENLABS:
                    elevenlabs = true;
                    break;
            }
        }
        const selected_voices = voices[engine];
        let enableAudio = (selected_voices && selected_voices.length) ? true : false;
        let getVoicesActionId = null;
        if (!any_voices) {
            getVoicesActionId = uuid.v4();
            VoiceActions.getVoices(getVoicesActionId,{polly,elevenlabs});
        }
        
        this.state = {
            engine,voice_id, voices, sample_text, enableAudio, getVoicesActionId, VOICE_ENGINES,
        };

        
        this.unsubscribes = [VoiceStore.listen(this.onStoreChange)];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
 
    onStoreChange=(storeState)=>{
        if (storeState.action.id === this.state.getVoicesActionId) {
            let voices = {};
            const VOICE_ENGINES = storeState.VOICE_ENGINES;
            for (var i in VOICE_ENGINES) {
                let engine_record = VOICE_ENGINES[i];
                if (engine_record.voices && engine_record.voices.length) {
                    voices[engine_record.engine] = engine_record.voices;
                }
            }
            let enableAudio = (voices[this.state.engine] && voices[this.state.engine].length) ? true : false;
            this.setState({VOICE_ENGINES, voices, enableAudio, getVoicesActionId:null});
        }
    }

    setEngine=(e)=>{
        const engine = e.target.value;
        const selected_voices = this.state.voices[engine];
        let changes = {
            engine,
            enableAudio:selected_voices ? true : false
        };
        let voice_id = this.state.voice_id;
        if (selected_voices && !_.find(selected_voices,{Id: voice_id})) {
            changes.voice_id = selected_voices[0].Id;
        }
        this.setState(changes);
    }
    
    setVoice=(e)=>{
        let voice_id = e.target.value;
        this.setState({voice_id});
    }
    
    setSampleText=(e)=>{
        this.setState({sample_text: e.target.value });
    }
    
    disableAudio=()=>{
        this.setState({enableAudio:false});
    }
    
    enableAudio=()=>{
        this.setState({enableAudio:true});
    }

    setVoiceOptions=()=>{
        let engine = this.state.engine;
        let voice_id = this.state.voice_id;
        const selected_voices = this.state.voices[engine];
        if (!selected_voices) {
            engine = '';
            voice_id = '';
        }
        this.props.onChangeVoiceOptions({
            engine, voice_id,
        });
        this.props.closeHandler();
    }

    render() {
        const engine = this.state.engine;
        const VOICE_ENGINES = this.state.VOICE_ENGINES;
        const selected_voices = this.state.voices[engine];
        const sample_text = this.state.sample_text;
        const voice_id = selected_voices ? this.state.voice_id : '';
        let canRequestStream = false;
        let audio_src = "";
        let audio_key = "";
        if (this.state.enableAudio && voice_id && selected_voices && sample_text && _.find(selected_voices,{Id: voice_id})) {
            canRequestStream = true;
            audio_src = VoiceStore.getStreamUrl({
                engine:this.state.engine,
                voice_id,
                phrase: this.state.sample_text,
                usageData: this.props.usageData,
            });
            audio_key = md5(engine + voice_id + sample_text);
        }
        let anyChanges = false;
        if (this.props.options) {
            let p_engine = this.props.options.engine || '';
            let p_voice = this.props.options.voice || '';
            if ((engine != p_engine) || (voice_id !== p_voice)) {
                anyChanges = true;
            }
        }
        else if (engine) {
            anyChanges = true;
        }
        
        return (
            <Modal
                className="voice-options-modal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                onHide={this.props.closeHandler}
                aria-labelledby="voice-options-title"
            >
                <Modal.Header closeButton closeLabel={Strings['en'].common.CLOSE} onHide={this.props.closeHandler}>
                    <Modal.Title id="voice-options-title">{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="voice-options-body">
                        <div className="edit-selector">
                            <label>{Strings['en'].voice_options.Engine + ':'}</label>
                            <select className="voice-engine-dropdown" value={this.state.engine} onChange={this.setEngine}>
                                {_.map(VOICE_ENGINES,(entry,k)=>(
                                    <option key={k} value={entry.engine}>{entry.displayName}</option>
                                ))}
                                <option key="none" value="">{Strings['en'].voice_options.NoVoice}</option>
                            </select>
                        </div>
                        {selected_voices ? 
                        <div className="edit-selector">
                            <label>{Strings['en'].voice_options.Voice + ':'}</label>
                            <select className="voice-engine-dropdown" value={this.state.voice_id} onChange={this.setVoice}>
                                {_.map(selected_voices,(entry,k)=>(
                                    <option key={k} value={entry.Id}>{`${entry.Name} (${entry.Gender})`}</option>
                                ))}
                                <option key="none" hidden value="">{Strings['en'].voice_options.SelectVoice + '...'}</option>
                            </select>
                        </div>
                        : null }
                        { selected_voices ? 
                        <div className="edit-selector">
                            <label>{Strings['en'].voice_options.sample_text_label + ':'}</label>
                            <textarea
                                value={this.state.sample_text}
                                rows='4'
                                onChange={this.setSampleText}
                                onFocus={this.disableAudio}
                                onBlur={this.enableAudio}
                            />
                        </div>
                        : null }
                        { audio_src ? 
                        <audio controls key={audio_key}>
                            <source type="audio/mp3" src={audio_src}/>
                        </audio>
                        : null }
                        <button className="btn btn-primary update-button" title={Strings['en'].common.UPDATE} disabled={!anyChanges} onClick={this.setVoiceOptions}>
                            {Strings['en'].common.UPDATE}
                        </button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // VoiceOptionsModal

VoiceOptionsModal.propTypes = propTypes;
VoiceOptionsModal.defaultProps = defaultProps;

export default VoiceOptionsModal;